export default __webpack_public_path__ + "static/Austin-443c3baa796a69617f2213c3b2c70162.webp";